module.exports = __webpack_public_path__ + "img/logo.4e265b69.png";